import { render, staticRenderFns } from "./GetToken.vue?vue&type=template&id=314cd59a&scoped=true"
import script from "./GetToken.vue?vue&type=script&lang=js"
export * from "./GetToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314cd59a",
  null
  
)

export default component.exports